import { render } from "./Withholding_Tax.vue?vue&type=template&id=30222d4e"
import script from "./Withholding_Tax.vue?vue&type=script&lang=js"
export * from "./Withholding_Tax.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__